export default "__VITE_ASSET__35346768__"